import React from "react";

import { useDispatch, useSelector } from "react-redux";
import AppState from "../../../../../store/AppState";
import { selectIsModalOpen } from "../../../../../store/modal/ModalSelectors";
import { Box, CircularProgress } from "@material-ui/core";
import { Typography, useTheme } from "@mui/material";
import { setModalState } from "../../../../../store/modal/ModalActions";
import { useIntl } from "react-intl";
import {
  deleteUnifiedBusinessRuleByRuleId,
  loadUnifiedSortingRulesList,
} from "../../../../../store/businessRules-list/BusinessRulesListActions";
import {
  selectIsBusinessRuleDeleted,
  selectIsBusinessRuleIdDeleted,
} from "../../../../../store/businessRules-list/BusinessRuleslistSelectors";
import CustomDialog from "../../../../common/DialogContainer";
import { Theme } from "@mui/material";
import { styled } from "@mui/material";
import ButtonComponent from "../../../../../components/common/ButtonComponent";

const styleClass = {
  overlay: "overlay",
};
const StyledDiv = styled("div")(({ theme }) => ({
  [`&.${styleClass.overlay}`]: {
    position: "fixed",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: 99999,
    cursor: "pointer",
  },
}));

const useStyles = (theme: Theme) => {
  return {
    dialogPaper: {
      maxHeight: "50vh",
    },
    confirmationText: {
      fontSize: 18,
      marginBottom: 10,
      fontWeight: 400,
      color: theme.palette.text.primary,
      fontFamily: "Helvetica",
    },
    btnParent: {
      display: "flex",
      justifyContent: "flex-end",
      margin: "20px",
    },
    overlay: {
      position: "fixed",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 99999,
      cursor: "pointer",
    },
  };
};

const DeleteModal = ({ ruleId, name }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const classes = useStyles(theme);
  const intl = useIntl();
  const isModalOpen = useSelector((state: AppState) =>
    selectIsModalOpen(state, "DeleteModal"),
  );
  const isDeleted = useSelector(selectIsBusinessRuleDeleted);
  const isRuleDeleted = useSelector(selectIsBusinessRuleIdDeleted);
  React.useEffect(() => {
    if (isRuleDeleted) {
      dispatch(setModalState("DeleteModal", false));
      dispatch(loadUnifiedSortingRulesList());
    }
  }, [isRuleDeleted, dispatch]);
  const handleClose = () => {
    dispatch(setModalState("DeleteModal", false));
  };
  const handleDeleteBusinessRuleByRuleId = (ruleId: string) => {
    dispatch(deleteUnifiedBusinessRuleByRuleId(ruleId));
  };

  const deleteSortingRuleModalTitle = () => {
    return (
      <Typography variant="inherit">
        {intl.formatMessage({
          id: "deleteSortingRuleModal.deleteHeader",
          defaultMessage: "Delete Sorting Rule",
        })}
      </Typography>
    );
  };

  const deleteSortingRuleModalContent = () => {
    return (
      <>
        <Box sx={classes.confirmationText}>
          <Typography variant="subtitle1">
            {intl.formatMessage({
              id: "deleteSortingRuleModal.delete",
              defaultMessage: "Are you sure you want to delete the ",
            })}{" "}
            {name + " ?"}
          </Typography>
        </Box>
        <Box sx={classes.btnParent}>
          <ButtonComponent
            color="secondaryButtonColorCTABlue"
            variant="outlined"
            onClick={handleClose}
          >
            {intl.formatMessage({
              id: "deleteSortingRuleModal.no",
              defaultMessage: "No",
            })}
          </ButtonComponent>
          <ButtonComponent
            color="primary"
            variant="contained"
            justifyContent="center"
            onClick={() => handleDeleteBusinessRuleByRuleId(ruleId)}
          >
            {intl.formatMessage({
              id: "deleteSortingRuleModal.yes",
              defaultMessage: "Yes",
            })}
          </ButtonComponent>
        </Box>
      </>
    );
  };

  return (
    <div>
      {isDeleted && (
        <StyledDiv className={styleClass.overlay}>
          <CircularProgress />
        </StyledDiv>
      )}
      <CustomDialog
        open={isModalOpen}
        onClose={handleClose}
        title={deleteSortingRuleModalTitle()}
        fullWidth
        maxWidth={"sm"}
      >
        {deleteSortingRuleModalContent()}
      </CustomDialog>
    </div>
  );
};

export default DeleteModal;
